export function firstObjectKey(obj, fallback = null) {
  for (let key of Object.keys(obj)) {
    if (obj[key]) {
      return key;
    }
  }
  return fallback;
}
